import { useLocalSearchParams } from 'expo-router';
import { useDepositCashFlow } from 'features/moveMoney/providers/DepositCashFlowContextProvider';
import { getDepositCashFlowNameFromParam } from 'features/moveMoney/utils/getDepositCashFlowNameFromParam';
import { useEffect } from 'react';

type Params = { flowSource?: string | string[] };

export function useDepositCashFlowFromRoute() {
  const { flowSource } = useLocalSearchParams<Params>();
  const { flowName, setFlowName } = useDepositCashFlow();

  const normalizedFlowName = getDepositCashFlowNameFromParam(flowSource);

  useEffect(() => {
    if (flowName !== normalizedFlowName) {
      setFlowName(normalizedFlowName);
    }
  }, [flowName, normalizedFlowName, setFlowName]);

  return {
    flowName: normalizedFlowName ?? flowName,
    setFlowName,
  };
}
